import {
  CircularProgress,
  Collapse, Grid,
  Table, TableBody, TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {makeStyles} from "@material-ui/styles";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import DesignationsRow from "../acordionRows/DesignationsRow";
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  form: {
    height: '100%',
  },
  field: {
    '& label.Mui-focused': {
      color: '#000',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#000',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#000',
      },
    },
  },
  tabActive: {
    color: '#1E69E5',
  },
  associationLink: {
    position: 'absolute',
    top: '-10px',
    right: '10px',
    cursor: 'pointer',
    decoration: 'none',
    '&:hover': {
      decoration: 'none',
    }
  },
  inheritFontWeight: {
    fontWeight: 'inherit',
  },
  tableMarginTop: {
    marginTop: 24,
  },
}));

const Designations = (props) => {
  const classes = useStyles();

  const [designations, setDesignations] = useState([]);
  const [status, setStatus] = useState('fetching');

  const {
    contact,
    handleTabChange,
    tab,
    tabNumber,
    itemType,
    adminUserSession,
  } = props;

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${contact.crdId}/designations`,
      {
        params: { entity_type: itemType },
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { designations, status } = response.data;

      setStatus(status);
      setDesignations(designations);
    });
  }, []);

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, tabNumber)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === tabNumber ? classes.tabActive : ''}`}>Designations</Typography>
        {status !== 'fetched' ? <CircularProgress /> : ''}
        {tab === tabNumber ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === tabNumber}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            <Grid container spacing={3} >
              <Grid
                item
                md={6}
                xs={12}
              >
                contact_has_reported_professional_designation
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                {itemType === 'IA' ? contact.contact_has_reported_professional_designation : contact.contact_has_reported_professional_designation_db}
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                contact_actvAGReg_TBD
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                {itemType === 'IA' ? contact.contact_actv_ag_reg_tbd : contact.contact_actv_ag_reg_tbd_db}
              </Grid>
            </Grid>

            <Table className={classes.tableMarginTop}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.inheritFontWeight}>exam_id</TableCell>
                  <TableCell className={classes.inheritFontWeight}>exam_date</TableCell>
                  <TableCell className={classes.inheritFontWeight}>exam_name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <DesignationsRow designations={designations}/>
              </TableBody>
            </Table>
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default Designations;